import React from 'react';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { MobileInternalHeader } from '../components/layout/MobileInternalHeader';
import { DoctorConsultation } from '../components/services/DoctorConsultation';
export function DoctorConsultationPage() {
  return <main className="flex-grow bg-gray-50 pt-14 md:pt-[var(--header-height-desktop)]" data-id="element-7771" data-mp="2j523latzw5bk">
      <div className="fixed inset-x-0 top-0 z-50 md:hidden" data-id="element-7772" data-mp="259qb7a3baqxt">
        <MobileInternalHeader title="Doctor Consultation" data-id="element-7773" data-mp="2a7rrjn9csc5l" />
      </div>
      <PageHeroBreadcrumb breadcrumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Doctor Consultation'
    }]} title="Doctor Consultation" description="Get expert medical advice from licensed healthcare professionals from the comfort of your home." data-id="element-7774" data-mp="1v9pode68hsov" />
      <div className="container mx-auto px-4 py-8 pb-24 md:pb-8" data-id="element-7775" data-mp="3ukhc9bvkglmi">
        <div className="max-w-3xl mx-auto" data-id="element-7776" data-mp="1ov2o7fk7merc">
          <DoctorConsultation data-id="element-7777" data-mp="1otrk1emur4zp" />
        </div>
      </div>
      <MobileFooterNav data-id="element-7778" data-mp="1jw848aaiak5n" />
    </main>;
}